import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import SearchBar from './components/SearchBar';
import FloatingSearchBar from './components/FloatingSearchBar/FloatingSearchBar';
import PriceModal from './components/PriceModal';
import PropertyGrid from './components/PropertyGrid';
import LocationHeader from './components/LocationHeader';
import ManagerDashboard from './pages/ManagerDashboard';
import ReferralDashboard from './pages/ReferralDashboard';
import PricingPage from './pages/PricingPage';
import InvitePage from './pages/InvitePage';
import FAQPage from './pages/FAQPage';
import BookingWizard from './components/booking-wizard/BookingWizard';
import StaysPage from './pages/StaysPage';
import ExperiencesPage from './pages/ExperiencesPage';
import HostHomesPage from './pages/host/HostHomesPage';
import BecomeHostPage from './pages/BecomeHostPage';
import PropertyDetails from './pages/PropertyDetails';
import PageWrapper from './components/layout/PageWrapper';
import useModal from './hooks/useModal';

const HomePage = () => {
  const navigate = useNavigate();

  const handlePropertyClick = (propertyId: string) => {
    navigate(`/property/${propertyId}`);
  };

  return (
    <PageWrapper withSearchBar>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="mt-8">
          <LocationHeader title="Logements populaires · Batroun" />
          <div onClick={() => handlePropertyClick('1')} className="cursor-pointer">
            <PropertyGrid />
          </div>
        </div>
        <div className="mt-16">
          <LocationHeader title="Logements disponibles le mois prochain · Paris" />
          <div onClick={() => handlePropertyClick('2')} className="cursor-pointer">
            <PropertyGrid />
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

const App: React.FC = () => {
  const { isOpen, close } = useModal(false);

  return (
    <Router>
      <AuthProvider>
        <div className="relative min-h-screen">
          <Header />
          <SearchBar />

          <Routes>
            <Route path="/stays" element={<StaysPage />} />
            <Route path="/experiences" element={<ExperiencesPage />} />
            <Route path="/host/homes" element={<HostHomesPage />} />
            <Route path="/become-a-host" element={<BecomeHostPage />} />
            <Route path="/manager/*" element={<ManagerDashboard />} />
            <Route path="/refer" element={<ReferralDashboard />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/booking/*" element={<BookingWizard />} />
            <Route path="/invite" element={<InvitePage />} />
            <Route path="/property/:id" element={<PropertyDetails />} />
            <Route path="/" element={<HomePage />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
};

export default App;